import { withOverlayLoader } from '../helpers.js';
import { memberRoutes, memberNavigateTo, consumeOtpResendPrompt } from './member-nav-config.js';
import { navigateWithOverlay } from '../shared/guarded-navigation.js';
import { handleMemberSpaRequestError } from './member-spa-auth.js';
import { showAlertMsg } from './member-show-alert-msg.js';

export function setLoginFlowBars(show) {
    $('body').toggleClass('login-flow-active', !!show);
}

function openOtpResendPage(promptMessage) {
    withOverlayLoader({
        url: memberRoutes().memberOtpResend,
        type: 'GET',
        success(data) {
            $('#index_paging').empty().html(data).fadeIn('slow');
            setLoginFlowBars(true);
            memberNavigateTo('signIn');
            if (typeof promptMessage === 'string' && promptMessage !== '') {
                showAlertMsg(promptMessage, 'danger');
            }
        },
        error: handleMemberSpaRequestError,
    });
}

export function MemberLoginPage() {
    const otpPrompt = consumeOtpResendPrompt();
    if (otpPrompt !== null) {
        openOtpResendPage(otpPrompt);
        return;
    }

    navigateWithOverlay({
        url: memberRoutes().memberLogin,
        type: 'GET',
        success(data) {
            $('#index_paging').empty().html(data).fadeIn('slow');
            setLoginFlowBars(true);
            memberNavigateTo('signIn');
        },
        error: handleMemberSpaRequestError,
    });
}

export function resendOTP() {
    withOverlayLoader({
        url: memberRoutes().memberOtpResend,
        type: 'GET',
        success(data) {
            $('#index_paging').empty().html(data).fadeIn('slow');
            setLoginFlowBars(true);
        },
        error: handleMemberSpaRequestError,
    });
}
